
    import {defineComponent, ref, reactive, toRefs, inject, computed, onMounted} from "vue";
    import {ErrorMessage, Field, Form} from "vee-validate";
    import {useStore} from "vuex";
    import {useRouter, useRoute} from "vue-router";
    import {Tab} from "bootstrap";
    import {useI18n} from 'vue-i18n';
    import AOS from "aos";
    import * as _ from "lodash";

    import FormInput from '@/views/programs/components/FormInput.vue'
    import FormFileInput from '@/views/programs/components/FormFileInput.vue'
    import FormDateInput from '@/views/programs/components/FormDateInput.vue'
    import FormCheckboxInput from '@/views/programs/components/FormCheckboxInput.vue'
    import RecursiveSelect from '@/views/programs/components/RecursiveSelect.vue'
    import FormBuilder from '@/views/programs/components/FormBuilder.vue'

    export default defineComponent({
        name: "apply",
        components: {
            Tab,

            Field,
            Form,
            ErrorMessage,

            FormBuilder,
            RecursiveSelect,
            FormCheckboxInput,
            FormDateInput,
            FormFileInput,
            FormInput,
        },
        setup(props, context) {
            const helpers: any = inject("helpers");
            const store = useStore();
            const router = useRouter();
            const route = useRoute();
            const i18n = useI18n();
            const {t} = useI18n();

            const user = computed(() => {
                return store.getters['moduleAuth/getAuthUser'];
            });

            let emptyArray: any = [];
            const state = reactive({
                loading: false,
                started: false,
                acceptTerms: false,
                userCanApply: false,

                ProgramData: null,
                steps: emptyArray,
            });

            onMounted(() => {
                AOS.init();
                getProgram();
            });

            const getProgram = () => {
                state.loading = true;
                let id: any = route?.params?.id;
                store.dispatch("modulePrograms/findProgramDetails", {id: id})
                    .then(({data}) => {
                        state.loading = false;
                        let response = data.data;
                        state.ProgramData = data.data;
                        state.userCanApply = data.data.userCanApply || false;
                        state.steps = response.dynamicFormsJsonWithOrder
                    })
                    .catch((response) => {
                        state.loading = false;
                        helpers.handleResponse(response, t, router, store, {});
                    });
            };

            const goToApplyPrograms = (item) => {
                router.push({name: 'apply_program_page', params: {id: item._id}})
            };

            return {
                ...toRefs(state),
                goToApplyPrograms,
                i18n,
                store,
                user,
            };
        },
    });
